import React, { createContext, useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-apollo';
import _get from 'lodash/get';
import clientError from '../../../apollo/queries/clientError.graphql';
import ErrorMessage from './ErrorMessage';
import { ERROR_CODES, ERROR_MESSAGES } from './messageActions';

const ErrorHandlerContext = createContext();
const useErrorHandler = () => useContext(ErrorHandlerContext);
const ErrorHandler = ({ children }) => {
  const [error, setError] = useState(undefined);

  const handleError = useCallback(e => {
    console.error('Error catcher:', e);
    setError('error');
  }, []);

  const renderContent = () => {
    const { data } = useQuery(clientError, { skip: !error });
    if (error) {
      if (data && data.clientError && data.clientError.id) {
        const errorMessage =
          ERROR_MESSAGES[
            _get(data.clientError, 'errorCode', ERROR_CODES.GENERIC)
          ] || '';
        const traceId = _get(data.clientError, 'traceId', '');
        return (
          <ErrorMessage
            message={errorMessage.message}
            traceId={traceId}
            actionButtonText={errorMessage.action}
            onClick={errorMessage.callback}
          />
        );
      }

      return <ErrorMessage />;
    }

    return children;
  };

  return (
    <ErrorHandlerContext.Provider value={{ handleError }}>
      {renderContent()}
    </ErrorHandlerContext.Provider>
  );
};

export default ErrorHandler;
export { useErrorHandler };

ErrorHandler.propTypes = {
  children: PropTypes.node.isRequired,
};
